module.exports = __webpack_public_path__ + "images/application/empty-eyes@2x-5208830a.png";